import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHelpEnabled } from "../context";

/**
 * A small question mark. Its text (help.<id> in the locale files) shows only
 * while the pointer is over it, or after a tap on a phone. Hidden when the
 * user switched the help off.
 */
export function Help({ id }: { id: string }) {
  const { t } = useTranslation();
  const enabled = useHelpEnabled();
  const [open, setOpen] = useState(false);
  if (!enabled) return null;
  return (
    <span className={open ? "tip open" : "tip"} onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        className="tip-mark"
        aria-label={t("help.ariaLabel")}
        aria-expanded={open}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        onBlur={() => setOpen(false)}
        onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
      >
        ?
      </button>
      <span className="tip-bubble" role="tooltip">
        {t(`help.${id}`)}
      </span>
    </span>
  );
}
